import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link } from "react-router-dom";
import LegalBackToLogin from "../components/LegalBackToLogin";
const styles = {
    page: {
        minHeight: "100vh",
        background: "radial-gradient(circle at top, rgba(0,255,255,0.12), transparent 36%), linear-gradient(180deg, #020617 0%, #050816 45%, #020617 100%)",
        color: "#eaffff",
        padding: "48px 18px",
        fontFamily: "Inter, system-ui, -apple-system, BlinkMacSystemFont, sans-serif",
    },
    card: {
        maxWidth: 980,
        margin: "0 auto",
        border: "1px solid rgba(120,255,255,0.22)",
        background: "rgba(4,12,24,0.86)",
        borderRadius: 28,
        boxShadow: "0 24px 80px rgba(0,0,0,0.45)",
        padding: "34px clamp(20px, 4vw, 48px)",
        backdropFilter: "blur(18px)",
    },
    eyebrow: {
        color: "#8ff7ff",
        letterSpacing: 2,
        textTransform: "uppercase",
        fontSize: 12,
        fontWeight: 800,
        marginBottom: 10,
    },
    title: {
        fontSize: "clamp(32px, 5vw, 52px)",
        lineHeight: 1.02,
        margin: "0 0 10px",
        color: "#ffffff",
    },
    date: {
        color: "#b9f8ff",
        marginBottom: 28,
        fontSize: 15,
    },
    section: {
        marginTop: 28,
        paddingTop: 22,
        borderTop: "1px solid rgba(143,247,255,0.12)",
    },
    h2: {
        color: "#9ffcff",
        fontSize: 22,
        margin: "0 0 10px",
    },
    p: {
        color: "rgba(234,255,255,0.86)",
        fontSize: 16,
        lineHeight: 1.75,
        margin: "8px 0",
    },
    list: {
        color: "rgba(234,255,255,0.86)",
        lineHeight: 1.75,
        paddingLeft: 22,
    },
    nav: {
        display: "flex",
        gap: 14,
        flexWrap: "wrap",
        marginTop: 36,
        paddingTop: 24,
        borderTop: "1px solid rgba(143,247,255,0.16)",
    },
    link: {
        color: "#8ff7ff",
        textDecoration: "none",
        fontWeight: 800,
    },
    footer: {
        marginTop: 22,
        color: "rgba(234,255,255,0.66)",
        fontSize: 13,
        lineHeight: 1.6,
    },
};
export default function Credits() {
    return (_jsx("main", { style: styles.page, children: _jsxs("article", { style: styles.card, children: [_jsx("div", { style: styles.eyebrow, children: "AVAAIO Legal" }), _jsx("h1", { style: styles.title, children: "Credits & Acknowledgments" }), _jsx("div", { style: styles.date, children: "Effective Date: May 7, 2026" }), _jsxs("section", { style: styles.section, children: [_jsx("h2", { style: styles.h2, children: "Thank You" }), _jsx("p", { style: styles.p, children: "AVAAIO\u2122 is built with appreciation for the developers, designers, researchers, open-source maintainers, educators, and technology communities whose work helps make modern AI software possible." })] }), _jsxs("section", { style: styles.section, children: [_jsx("h2", { style: styles.h2, children: "Platform" }), _jsx("p", { style: styles.p, children: "AVAAIO\u2122 is built and operated by American Globalo, LLC. Ava is the AI assistant experience inside the AVAAIO\u2122 platform." })] }), _jsxs("section", { style: styles.section, children: [_jsx("h2", { style: styles.h2, children: "Technologies and Communities" }), _jsxs("ul", { style: styles.list, children: [_jsx("li", { children: "OpenAI and modern AI research communities" }), _jsx("li", { children: "React, Vite, TypeScript, JavaScript, Node.js, and web platform contributors" }), _jsx("li", { children: "Three.js and 3D web graphics contributors" }), _jsx("li", { children: "FastAPI, Python, Linux, Nginx, and cloud infrastructure communities" }), _jsx("li", { children: "Speech, accessibility, security, and open-source software communities" })] })] }), _jsxs("section", { style: styles.section, children: [_jsx("h2", { style: styles.h2, children: "Third-Party Rights" }), _jsx("p", { style: styles.p, children: "Third-party names, trademarks, frameworks, libraries, services, and technologies remain the property of their respective owners. References are provided for acknowledgment and transparency only and do not imply endorsement." })] }), _jsxs("section", { style: styles.section, children: [_jsx("h2", { style: styles.h2, children: "Creator Acknowledgment" }), _jsx("p", { style: styles.p, children: "AVAAIO\u2122 exists because of continued work, testing, vision, and dedication toward building a helpful, safer, and more capable AI assistant experience." })] }), _jsx(LegalBackToLogin, {}), _jsxs("nav", { style: styles.nav, "aria-label": "Legal navigation", children: [_jsx(Link, { style: styles.link, to: "/privacy-policy", children: "Privacy Policy" }), _jsx(Link, { style: styles.link, to: "/terms-and-conditions", children: "Terms & Conditions" }), _jsx(Link, { style: styles.link, to: "/ai-disclaimer", children: "AI Disclaimer" }), _jsx(Link, { style: styles.link, to: "/credits", children: "Credits & Acknowledgments" })] }), _jsxs("footer", { style: styles.footer, children: ["\u00A9 2026 American Globalo, LLC. All rights reserved.", _jsx("br", {}), "AVAAIO\u2122 is owned and operated by American Globalo, LLC. Ava is the AI assistant experience within the AVAAIO\u2122 platform.", _jsx("br", {}), "Support: support@avaaio.com"] })] }) }));
}
